import './index.css';

const ConfirmExit = ({ component, handleExit, yesText='Yes', noText='No' }) => {
  return (
    <div className='confirm-exit-popup'>
      <div className='card'>
        <h2>Exit?</h2>
        <hr />
        <div className='message'>
          Are you sure you want to exit{component ? ` ${component}` : ''} ?
        </div>
        <div className='buttons'>
          <button onClick={() => handleExit(true)}>{yesText}</button>
          <button onClick={() => handleExit(false)}>{noText}</button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmExit;